import React, { useState } from 'react';
import './LWCBrochure.css';
import { useParams, useNavigate } from 'react-router-dom';


const LWCBrochure = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [expandedFaq, setExpandedFaq] = useState(null);
  const [expandedWeek, setExpandedWeek] = useState(null); // Add this line
  const navigate = useNavigate();

  // Add this function
  const toggleWeek = (weekNumber) => {
    setExpandedWeek(expandedWeek === weekNumber ? null : weekNumber);
  };

  

  const toggleFaq = (index) => {
    setExpandedFaq(expandedFaq === index ? null : index);
  };

  const faqs = [
    {
      question: "Is prior Salesforce experience required?",
      answer: "Basic JavaScript knowledge is recommended, but we cover all necessary Salesforce fundamentals during the course."
    },
    {
      question: "What certifications does this prepare me for?",
      answer: "This course prepares you for Platform Developer I and JavaScript Developer I certifications, with coverage of LWC-specific topics."
    },
    {
      question: "How is this different from Aura components?",
      answer: "LWC is Salesforce's modern, standards-based framework that offers better performance and aligns with web components standards."
    }
  ];

  return (
    <div className="course-brochure">
      <header className="brochure-header">
        <h1>Salesforce LWC Developer Program</h1>
        <p className="subtitle">Master Lightning Web Components in 45 days and become a high-demand Salesforce developer</p>
        <div className="header-highlights">
          <div className="highlight-item">
            <span className="highlight-number">92%</span>
            <span className="highlight-label">Placement Rate</span>
          </div>
          <div className="highlight-item">
            <span className="highlight-number">45</span>
            <span className="highlight-label">Days Intensive</span>
          </div>
          <div className="highlight-item">
            <span className="highlight-number">3</span>
            <span className="highlight-label">Real Projects</span>
          </div>
        </div>
      </header>

      <div className="brochure-content">
        <div className="tabs">
          <button 
            className={`tab-btn ${activeTab === 'overview' ? 'active' : ''}`}
            onClick={() => setActiveTab('overview')}
          >
            Overview
          </button>
          <button 
            className={`tab-btn ${activeTab === 'curriculum' ? 'active' : ''}`}
            onClick={() => setActiveTab('curriculum')}
          >
            Curriculum
          </button>
          <button 
            className={`tab-btn ${activeTab === 'outcomes' ? 'active' : ''}`}
            onClick={() => setActiveTab('outcomes')}
          >
            Career Outcomes
          </button>
        </div>

        <div className="tab-content">
          {activeTab === 'overview' && (
            <div className="overview-content">
              <h2>Why LWC Developers Are In High Demand</h2>
              <div className="market-demand">
                <p>Lightning Web Components (LWC) has become the standard for Salesforce UI development, with:</p>
                <ul>
                  <li><strong>75%</strong> of new Salesforce implementations using LWC as their primary UI framework</li>
                  <li><strong>60%</strong> year-over-year growth in LWC developer job postings</li>
                  <li><strong>40%</strong> higher average salaries compared to Aura component developers</li>
                </ul>
                <p>Salesforce has made LWC their strategic framework for all future UI development, making these skills essential for any Salesforce developer.</p>
              </div>

              <div className="program-details">
                <div className="detail-card">
                  <h3>What You'll Learn</h3>
                  <ul>
                    <li>Modern JavaScript (ES6+) for Salesforce</li>
                    <li>LWC component architecture</li>
                    <li>Salesforce data integration patterns</li>
                    <li>Performance optimization techniques</li>
                    <li>Testing and debugging LWCs</li>
                  </ul>
                </div>

                <div className="detail-card">
                  <h3>Program Features</h3>
                  <ul>
                    <li>Daily hands-on coding exercises</li>
                    <li>3 real-world LWC projects</li>
                    <li>Weekly code reviews by Salesforce architects</li>
                    <li>GitHub portfolio development</li>
                    <li>Interview preparation workshops</li>
                  </ul>
                </div>
              </div>
            </div>
          )}

{activeTab === 'curriculum' && (
  <div className="curriculum-content">
    <h2>6-Week Intensive LWC Curriculum</h2>
    
    <div className="week-accordion">
      {/* Week 1 */}
      <div className={`week-card ${expandedWeek === 1 ? 'active' : ''}`} onClick={() => toggleWeek(1)}>
        <h3>Week 1: LWC Foundations & Setup</h3>
        {expandedWeek === 1 && (
          <div className="week-details">
            <h4>Day 1-2: Introduction to Salesforce Lightning & LWC</h4>
            <ul>
              <li>Evolution from Aura to LWC</li>
              <li>Performance benefits (Shadow DOM, ES6+)</li>
              <li>Salesforce Lightning Platform overview</li>
            </ul>
            
            <h4>Day 3-4: Environment Setup</h4>
            <ul>
              <li>Install Salesforce CLI and VS Code</li>
              <li>Set up Trailhead Playground</li>
              <li>Create & authorize a Salesforce project</li>
            </ul>
            
            <h4>Day 5: First LWC Component</h4>
            <ul>
              <li>Component structure (.js, .html, .css, .xml)</li>
              <li>Deploy to Salesforce Org using SFDX</li>
              <li>Debugging with Developer Console</li>
            </ul>
          </div>
        )}
      </div>

      {/* Week 2 */}
      <div className={`week-card ${expandedWeek === 2 ? 'active' : ''}`} onClick={() => toggleWeek(2)}>
        <h3>Week 2: JavaScript for LWC & Data Binding</h3>
        {expandedWeek === 2 && (
          <div className="week-details">
            <h4>Day 1-2: Modern JavaScript (ES6+)</h4>
            <ul>
              <li>Arrow functions, destructuring, modules</li>
              <li>Classes, async/await, Promises</li>
              <li>Template literals, spread/rest operators</li>
            </ul>
            
            <h4>Day 3-4: LWC Data Binding & Lifecycle</h4>
            <ul>
              <li>@track, @api, @wire decorators</li>
              <li>Lifecycle hooks (connectedCallback, renderedCallback)</li>
              <li>Reactivity system</li>
            </ul>
            
            <h4>Day 5: Styling with SLDS</h4>
            <ul>
              <li>Scoped CSS vs. external styles</li>
              <li>Salesforce Lightning Design System</li>
              <li>Responsive design best practices</li>
            </ul>
          </div>
        )}
      </div>

      {/* Week 3 */}
      <div className={`week-card ${expandedWeek === 3 ? 'active' : ''}`} onClick={() => toggleWeek(3)}>
        <h3>Week 3: LWC Communication & Events</h3>
        {expandedWeek === 3 && (
          <div className="week-details">
            <h4>Day 1-2: Parent-Child Communication</h4>
            <ul>
              <li>@api properties & public methods</li>
              <li>Custom event dispatching</li>
              <li>Event bubbling and composition</li>
            </ul>
            
            <h4>Day 3-4: Lightning Message Service (LMS)</h4>
            <ul>
              <li>Publish-subscribe model</li>
              <li>Cross-component communication</li>
              <li>Use cases for LMS</li>
            </ul>
            
            <h4>Day 5: Navigation in LWC</h4>
            <ul>
              <li>lightning/navigation module</li>
              <li>URL parameters & record pages</li>
              <li>External URL navigation</li>
            </ul>
          </div>
        )}
      </div>

      {/* Week 4 */}
      <div className={`week-card ${expandedWeek === 4 ? 'active' : ''}`} onClick={() => toggleWeek(4)}>
        <h3>Week 4: Working with Salesforce Data</h3>
        {expandedWeek === 4 && (
          <div className="week-details">
            <h4>Day 1-2: Apex Integration with @wire</h4>
            <ul>
              <li>@AuraEnabled methods</li>
              <li>Imperative Apex calls</li>
              <li>Error handling & loading states</li>
            </ul>
            
            <h4>Day 3-4: Lightning Data Service (LDS)</h4>
            <ul>
              <li>lightning-record-form components</li>
              <li>getRecord, getRecordUi adapters</li>
              <li>Record caching & refreshApex</li>
            </ul>
            
            <h4>Day 5: Data Optimization</h4>
            <ul>
              <li>Batch data loading</li>
              <li>Pagination & lazy loading</li>
              <li>Client-side caching strategies</li>
            </ul>
          </div>
        )}
      </div>

      {/* Week 5 */}
      <div className={`week-card ${expandedWeek === 5 ? 'active' : ''}`} onClick={() => toggleWeek(5)}>
        <h3>Week 5: Advanced LWC Concepts</h3>
        {expandedWeek === 5 && (
          <div className="week-details">
            <h4>Day 1-2: Dynamic Components</h4>
            <ul>
              <li>if:true/if:false directives</li>
              <li>Iterating with for:each</li>
              <li>Dynamic component creation</li>
            </ul>
            
            <h4>Day 3-4: Third-Party Libraries</h4>
            <ul>
              <li>Loading scripts via Static Resources</li>
              <li>Chart.js integration</li>
              <li>Best practices for external libraries</li>
            </ul>
            
            <h4>Day 5: Testing & Debugging</h4>
            <ul>
              <li>Jest unit testing framework</li>
              <li>Test coverage metrics</li>
              <li>Debugging in Chrome DevTools</li>
            </ul>
          </div>
        )}
      </div>

      {/* Week 6 */}
      <div className={`week-card ${expandedWeek === 6 ? 'active' : ''}`} onClick={() => toggleWeek(6)}>
        <h3>Week 6: Real-World Projects & Deployment</h3>
        {expandedWeek === 6 && (
          <div className="week-details">
            <h4>Day 1-2: Capstone Project 1 - Inventory Dashboard</h4>
            <ul>
              <li>Real-time data visualization</li>
              <li>Custom filtering components</li>
              <li>External API integration</li>
            </ul>
            
            <h4>Day 3-4: Capstone Project 2 - Appointment Scheduler</h4>
            <ul>
              <li>Calendar UI implementation</li>
              <li>Conflict detection logic</li>
              <li>Form validation</li>
            </ul>
            
            <h4>Day 5: Deployment & CI/CD</h4>
            <ul>
              <li>Change Sets vs. Metadata API</li>
              <li>GitHub Actions for CI/CD</li>
              <li>Production deployment checklist</li>
            </ul>
          </div>
        )}
      </div>
    </div>

    <div className="projects-showcase">
      <h3>Hands-On Projects You'll Build</h3>
      <div className="project-cards">
        <div className="project-card">
          <h4>Inventory Management Dashboard</h4>
          <ul>
            <li>Real-time stock level monitoring</li>
            <li>Interactive data filters</li>
            <li>Chart.js visualizations</li>
          </ul>
        </div>
        <div className="project-card">
          <h4>Appointment Booking System</h4>
          <ul>
            <li>Drag-and-drop calendar</li>
            <li>Automated conflict detection</li>
            <li>Email notification system</li>
          </ul>
        </div>
        <div className="project-card">
          <h4>Community Self-Service Portal</h4>
          <ul>
            <li>Experience Cloud integration</li>
            <li>Responsive mobile design</li>
            <li>Secure authentication flows</li>
          </ul>
        </div>
      </div>
    </div>

    <div className="certification-path">
      <h3>Certification Preparation</h3>
      <div className="cert-cards">
        <div className="cert-card">
          <h4>Platform Developer I</h4>
          <ul>
            <li>LWC fundamentals</li>
            <li>Apex integration</li>
            <li>Data modeling</li>
          </ul>
        </div>
        <div className="cert-card">
          <h4>JavaScript Developer I</h4>
          <ul>
            <li>ES6+ concepts</li>
            <li>DOM manipulation</li>
            <li>Asynchronous programming</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
)}

          {activeTab === 'outcomes' && (
            <div className="outcomes-content">
              <h2>Career Paths for LWC Developers</h2>
              
              <div className="outcome-stats">
                <div className="stat-card">
                  <h3>Average Salary</h3>
                  <p className="stat-value">$115,000</p>
                  <p>for LWC developers in the US</p>
                </div>
                
                <div className="stat-card">
                  <h3>Job Growth</h3>
                  <p className="stat-value">68%</p>
                  <p>increase in LWC positions since 2022</p>
                </div>
              </div>

              <h3>Career Opportunities</h3>
              <ul className="job-roles">
                <li>Salesforce LWC Developer</li>
                <li>Lightning UI Specialist</li>
                <li>Front-End Salesforce Developer</li>
                <li>Salesforce Technical Architect</li>
              </ul>

              <div className="testimonial">
                <blockquote>
                  "After completing this LWC program, I received three job offers within two weeks. The hands-on project experience made all the difference in my interviews."
                </blockquote>
                <p className="testimonial-author">- David K., Salesforce Developer at Cloud Solutions Inc.</p>
              </div>

              <div className="certification-path">
                <h3>Certification Pathway</h3>
                <div className="cert-cards">
                  <div className="cert-card">
                    <h4>Platform Developer I</h4>
                    <p>Covers foundational LWC concepts</p>
                  </div>
                  <div className="cert-card">
                    <h4>JavaScript Developer I</h4>
                    <p>Validates advanced JavaScript skills</p>
                  </div>
                  <div className="cert-card">
                    <h4>Platform Developer II</h4>
                    <p>Includes complex LWC implementations</p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="faq-section">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-container">
            {faqs.map((faq, index) => (
              <div className={`faq-item ${expandedFaq === index ? 'expanded' : ''}`} key={index}>
                <button className="faq-question" onClick={() => toggleFaq(index)}>
                  {faq.question}
                  <span className="toggle-icon">{expandedFaq === index ? '-' : '+'}</span>
                </button>
                {expandedFaq === index && (
                  <div className="faq-answer">
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="cta-section">
          <h2>Ready to Become a Certified LWC Developer?</h2>
          <p>Next cohort begins: July 15, 2025</p>
          <button onClick={() => navigate('/enroll')} className="enroll-btn">Enroll Now</button>
          <p className="payment-options">Flexible payment plans and early-bird discounts available</p>
        </div>
      </div>
    </div>
  );
};

export default LWCBrochure;